/* Highly stripped down version of: https://github.com/mikemaccana/outdated-browser-rework */
/* eslint-disable no-var,vars-on-top,prefer-template */

import './OutdatedBrowser.scss';

function isBrowserOutOfDate() {
  try {
    return eval('(() => false)()'); // eslint-disable-line no-eval
  } catch (e) {
    console.error('Arrow functions not supported:', e); // eslint-disable-line no-console
  }

  return true;
}

function getmessage(updateSource) {
  var messages = {
    outOfDate: 'Selaimesi on vanhentunut!',
    update: {
      web: 'Lataa ajantasainen selain nähdäksesi tämän sivun oikein. ',
      googlePlay: 'Asenna uusin Chrome tai Firefox Google Play -kaupasta ',
      appStore: 'Päivitä iOS puhelimesi asetuksista'
    },
    url: 'http://outdatedbrowser.com/fi',
    callToAction: 'Päivitä selaimeni nyt',
    androidChrome: 'Asenna uusin Chrome',
    androidFirefox: 'Asenna uusin Firefox',
    close: 'Sulje'
  };

  var updateMessages = {
    web:
      '<p>' +
      messages.update.web +
      '<a id="buttonUpdateBrowser" rel="nofollow" href="' +
      messages.url +
      '">' +
      messages.callToAction +
      '</a></p>',
    googlePlay:
      '<p>' +
      messages.update.googlePlay +
      '<a id="buttonUpdateBrowser" rel="nofollow" href="https://play.google.com/store/apps/details?id=com.android.chrome">' +
      messages.androidChrome +
      '</a></p>' +
      '<p><a id="buttonUpdateBrowser" rel="nofollow" href="https://play.google.com/store/apps/details?id=org.mozilla.firefox">' +
      messages.androidFirefox +
      '</a></p>',
    appStore: '<p>' + messages.update[updateSource] + '</p>'
  };

  var updateMessage = updateMessages[updateSource];

  return (
    '<div class="vertical-center"><h6>' +
    messages.outOfDate +
    '</h6>' +
    updateMessage +
    '<p class="last"><a href="#" id="buttonCloseUpdateBrowser" title="' +
    messages.close +
    '">&times;</a></p></div>'
  );
}

function setEvents() {
  var buttonClose = document.getElementById('buttonCloseUpdateBrowser');

  buttonClose.onmousedown = function onCloseOutdatedBrowser(e) {
    e.preventDefault();
    buttonClose.onmousedown = null;

    var outdatedUi = document.getElementById('outdated');
    outdatedUi.parentNode.removeChild(outdatedUi);
  };
}

function main() {
  var isAndroid = /android/i.test(navigator.userAgent);
  var isIOS = /ios/i.test(navigator.userAgent);

  // Other possible values are 'googlePlay' or 'appStore'.
  // Determines where we tell users to go for upgrades.
  var updateSource = 'web';

  if (isAndroid) {
    updateSource = 'googlePlay';
  } else if (isIOS) {
    updateSource = 'appStore';
  }

  // Check if browser is supported
  var outdatedUi = document.getElementById('outdated');

  if (isBrowserOutOfDate()) {
    outdatedUi.innerHTML = getmessage(updateSource);
    outdatedUi.className = 'visible';

    setEvents();
  } else {
    outdatedUi.parentNode.removeChild(outdatedUi);
  }
}

main();
